export default __webpack_public_path__ + "static/media/healthInsurance.53e6a736.svg";